import { forwardRef, useCallback } from "react"

// --- Lib ---
import { parseShortcutKeys } from "lib/tiptap-utils"

// --- Hooks ---
import { useTiptapEditor } from "hooks/use-tiptap-editor"

import {useImageCarousel} from "./use-image-carousel";

import { Button } from "components/tiptap-ui-primitive/button"
import { Badge } from "components/tiptap-ui-primitive/badge"

export function ImageShortcutBadge({
}) {
  // return <Badge>{parseShortcutKeys({ shortcutKeys })}</Badge>;
}

/**
 * Button component for inserting image carousels in a Tiptap editor.
 *
 * For custom button implementations, use the `useImage` hook instead.
 */
export const ImageCarouselButton = forwardRef((
  {
    editor: providedEditor,
    text,
    hideWhenUnavailable = false,
    onInserted,
    showShortcut = false,
    onClick,
    icon: CustomIcon,
    children,
    ...buttonProps
  },
  ref
) => {
  const { editor } = useTiptapEditor(providedEditor)
  const {
    isVisible,
    canInsert,
    handleImageCarousel,
    label,
    isActive,
    // shortcutKeys,
    Icon,
  } = useImageCarousel({
    editor,
    hideWhenUnavailable,
    onInserted,
  })

  const handleClick = useCallback((event) => {
    onClick?.(event)
    if (event.defaultPrevented) return
    handleImageCarousel()
  }, [handleImageCarousel, onClick])

  if (!isVisible) {
    return null
  }

  const RenderIcon = CustomIcon ?? Icon

  return (
    <Button
      type="button"
      data-style="ghost"
      data-active-state={isActive ? "on" : "off"}
      role="button"
      tabIndex={-1}
      disabled={!canInsert}
      data-disabled={!canInsert}
      aria-label={label}
      aria-pressed={isActive}
      tooltip={label}
      onClick={handleClick}
      {...buttonProps}
      ref={ref}>
      {children ?? (
        <>
          <RenderIcon className="tiptap-button-icon" />
          {text && <span className="tiptap-button-text">{text}</span>}
          {/*{showShortcut && <ImageShortcutBadge shortcutKeys={shortcutKeys} />}*/}
        </>
      )}
    </Button>
  );
})

ImageCarouselButton.displayName = "ImageCarouselButton"
